import "./App.css";
import "./fonts/Inter/stylesheet.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Layout from "./layout/layout";
import Home from "./pages/home/Index";
import Contacts from "./components/main/Pages/Contacts";
import Pricing from "./components/main/Pages/Pricing";
import Login from "./pages/auth/Login";
import Registration from "./pages/auth/Registration";
import NotFound from "./layout/NotFound";
import AuthVk from "./pages/auth/ExternalAuthVk";
import AuthYa from "./pages/auth/ExternalAuthYa";
import BindVk from "./pages/auth/BindVk";
import BindYa from "./pages/auth/BindYa";
import Exit from "./pages/auth/Exit";

function App() {
  return (
    <div className="App">
      {
        //https://ru.hexlet.io/blog/posts/react-router-v6
        //https://react-bootstrap.github.io/docs/components/accordion
      }

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Login />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="login" element={<Login />} />
            <Route path="registration" element={<Registration />} />
            <Route path="exit" element={<Exit />} />
            <Route path="auth/vk" element={<AuthVk />} />
            <Route path="auth/ya" element={<AuthYa />} />
            <Route path="auth/bind/vk" element={<BindVk />} />
            <Route path="auth/bind/ya" element={<BindYa />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
